export enum DeviceServiceStatusEnum {
    Red = 1,
    Black,
    Yellow,
    Green,
    Blue,
    Violet
  }

